"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandLogo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const BrandLogo = ({ logoUrl }) => {
    const handleLogoError = (event) => (event.target.style.display = 'none');
    return ((0, jsx_runtime_1.jsx)(ui_react_1.CompanyWatermark, { src: logoUrl, onError: handleLogoError, style: { marginRight: '1rem' } }));
};
exports.BrandLogo = BrandLogo;
//# sourceMappingURL=brand_logo.js.map